<template>
  <Accordion #default="{ isOpen, handleFocus }">
    <AccordionSection
      :path="'Lane Hall Section 1.mp3'"
      :open="isOpen == 0"
      @open="handleFocus(0)"
    >
      <template #title>
        Barracks No. 1
      </template>
      <template #content>
        <p v-if="captions" class="content">
          Hello, and welcome to Lane Hall. Built in 1888 and originally known as
          “Barracks No. 1”, Lane Hall is still considered the symbolic home of
          the University’s Corps of Cadets. The building operated as a dorm and
          housed 130 students each year until it was converted to academic
          office use in 1967. Feel free to look around at some photos from the
          building's past.
        </p>
        <Carousel :images="lane" />
      </template>
    </AccordionSection>
    <AccordionSection
      :path="'Lane Hall Section 2.mp3'"
      :open="isOpen == 1"
      @open="handleFocus(1)"
    >
      <template #title>
        James L. Whitehurst, Jr.
      </template>
      <template #content>
        <p v-if="captions" class="content">
          In 1961, Lane Hall became the first dorm building on campus to house a
          Black student. Just like previous Black students, Whitehurst was
          prohibited from living or eating on campus for his first two years of
          college. After his sophomore year however, Whitehurst filed a
          grievance with the Civil Rights Office in Washington DC, demanding
          that Virginia Tech allow him to live on campus. The group was able to
          force President Newman and the Board of Visitors to change their
          policies regarding Blacks using campus facilities, and the
          University’s administration developed a plan to garner support for the
          integration of campus and the town among Blacksburg residents. In
          1961, James Whitehurst became the first Black student to live on
          Virginia Tech’s campus. Rather than assigned a typical room however,
          Whitehurst was assigned to live here in Lane Hall, and was given an
          entire bay of the building to share between him and his resident
          advisor. The same school year that Whitehurst became the first Black
          student to live on campus, he also broke another barrier to entry into
          Virginia Tech culture by becoming the first Black student to attend
          Ring Dance, one of Virginia Tech’s oldest and most honored traditions.
          In 1970, Whitehurst achieved another first, becoming the first Black
          person to serve on Virginia Tech’s Board of Visitors.
        </p>
        <Carousel :images="jamesWhitehurst" />
      </template>
    </AccordionSection>
  </Accordion>
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import AccordionSection from "@/components/AccordionSection.vue";
import Carousel from "@/components/Carousel.vue";

export default {
  name: "HogeAccordion",
  components: {
    Accordion,
    AccordionSection,
    Carousel
  },
  props: {
    captions: {
      type: Boolean
    }
  },
  data() {
    return {
      lane: [
        {
          name: "Lane Hall 1890",
          path: "Lane 1890.jpg",
          caption: "Lane Hall in 1890."
        },
        {
          name: "Cadets",
          path: "Cadets.png",
          caption: "Cadets next to Lane Hall."
        },
        {
          name: "Lane Hall",
          path: "Lane Hall.png",
          caption: "Lane Hall"
        }
      ],
      jamesWhitehurst: [
        {
          name: "James Whitehurst on Board of Visitors, 1972",
          path: "James Whitehurst on Board of Visitors, 1972.jpg",
          caption: "James Whitehurst on the Board of Visitors."
        },
        {
          name: "Lane Hall 2",
          path: "Lane Hall 2.png",
          caption: "Lane Hall with the Cadets."
        },
        {
          name: "Lane Hall 3",
          path: "Lane Hall 3.jpg",
          caption: "Lane Hall"
        }
      ]
    };
  }
};
</script>
